export const manifest = {
  screens: {
    scr_dxu6ol: { name: "Beta Landing", route: "/" },
  },
}
